<template>
  <ElConfigProvider
    size="large"
  >
    <router-view #default="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <Modals />
  </ElConfigProvider>
</template>
